import { Tooltip } from '@iveco-ti/iveco-ds'
import { UserRoundCheck, UserRoundMinus } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Can } from '@/common/components/Can'
import { useDeleteUser } from '../hooks/useDeleteUser'
import { UserPaginated, userPaginatedDTO } from '../hooks/usePaginateUsers'
import { useReactivateUser } from '../hooks/useReactivateUser'

type UserInactiveActionsProps = {
  user: UserPaginated
}

export function UserInactiveActions({ user }: UserInactiveActionsProps) {
  const { t } = useTranslation('registers')
  const { handleReactivateUser } = useReactivateUser()
  const { handleDeleteUser } = useDeleteUser()

  return (
    <div className="flex flex-row gap-2 items-start justify-center">
      <Can I="reactivate" this={userPaginatedDTO.parse(user)}>
        <Tooltip text={t('users.table.table_row.actions.reactivate')}>
          <button
            type="button"
            className="p-1 hover:bg-base-100 rounded"
            onClick={() => handleReactivateUser(user.id)}
          >
            <UserRoundCheck size={18} className="text-brand-700" />
          </button>
        </Tooltip>
      </Can>

      <Can I="delete" this={userPaginatedDTO.parse(user)}>
        <Tooltip text={t('users.table.table_row.actions.delete')}>
          <button
            type="button"
            className="p-1 hover:bg-base-100 rounded"
            onClick={() => handleDeleteUser(user.id)}
          >
            <UserRoundMinus size={18} className="text-danger-700" />
          </button>
        </Tooltip>
      </Can>
    </div>
  )
}
